import type { RouteRecordRaw } from "vue-router"
import PageHomeBuildings from "@modules/home/pages/PageHomeBuildings.vue"
import PageHomeFolder from "@modules/home/pages/PageHomeFolder.vue"

// ====================================
// Module home (accueil, dossiers, liste bâtiments)
// ====================================
export const routes = [
    {
        path: "building",
        name: "PageHomeBuildings",
        component: PageHomeBuildings,
        meta: {
            requiresAuth: true,
            layout: "header",
        },
    },
    {
        path: "folder",
        name: "PageHomeFolderRoot",
        component: PageHomeFolder,
        meta: {
            requiresAuth: true,
            layout: "header",
        },
    },
    {
        path: "folder/:folderId",
        name: "PageHomeFolder",
        component: PageHomeFolder,
        meta: {
            requiresAuth: true,
            layout: "header",
        },
    },
] as RouteRecordRaw[]
